export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
          📩 投稿爆料
        </h2>
        <p className="text-foreground-500 text-sm md:text-base mb-10 max-w-lg mx-auto">
          你有独家猛料？欢迎投稿爆料，瓜友的力量最强大
        </p>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <div className="text-sm font-bold text-foreground-900 mb-1">邮箱投稿</div>
              <div className="text-xs text-foreground-500">tips@51chigua.com</div>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <div className="text-sm font-bold text-foreground-900 mb-1">微信投稿</div>
              <div className="text-xs text-foreground-500">51chigua_official</div>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-message-2-line text-xl text-secondary-600"></i>
              </div>
              <div className="text-sm font-bold text-foreground-900 mb-1">在线投稿</div>
              <div className="text-xs text-foreground-500">点击下方按钮提交</div>
            </div>
          </div>

          <a
            href="#contact"
            onClick={(e) => e.preventDefault()}
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-bold rounded-full transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line"></i>
            立即投稿爆料
          </a>
        </div>
      </div>
    </section>
  );
}